<div>
        <res-collapsible-text-view
            text="{{ researchInfrastructure | hisTranslate : 'description'}}"
            header="fs.res.researchInfrastructure.ResearchInfrastructure.description"
            expandToolTip="fs.res.researchInfrastructure.view.showFullDescription"
            collapseToolTip="fs.res.researchInfrastructure.view.showShortDescription">
        </res-collapsible-text-view>
        
        <!-- später hier hinzufügen: Methodik, Nutzungsbedingungen
          <res-collapsible-text-view            
        </res-collapsible-text-view>  -->

        <div class="details">
            <div class="detailPresentationList">
                <div *ngIf="operators" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.researchInfrastructure.ResearchInfrastructure.operator' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent"><span id="span-operator">{{ getOperatorsAsString()}}</span></div>
                </div>
                <div *ngIf="coordinators" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.researchInfrastructure.ResearchInfrastructure.coordinator' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent"><span id="span-coordinator">{{getCoordinatorsAsString()}}</span></div>
                </div>
                
            </div>
        </div>
    </div>

